import React from 'react';

const NotFoundPage = () => {
  return (
    <main>
      <h1>Not Found Page</h1>
    </main>
  );
};

export default NotFoundPage;
